export default __webpack_public_path__ + "static/media/Restriction.bd64772f.pdf";